import React from 'react';
import PropTypes from 'prop-types';
import addMinutes from 'date-fns/add_minutes';
import format from 'date-fns/format';
import startOfDay from 'date-fns/start_of_day';
import styled from 'styled-components';
import { join, times } from 'lodash';
import { LOCATION_TYPES, toISOStringNoZone } from '../../../lib/dataLayer';
import {
  GridContainer,
  GridItem,
  TextFieldWrapper,
  DropdownWrapper,
  CheckboxWrapper,
  FrequencyForm,
} from '../../common';
import { Field } from 'formik';
import { MenuItem } from '@material-ui/core';
import {
  FREQUENCY,
  IDLE_TIME,
  LOCATION,
  NOTIFICATION_TEXT,
  STATUS,
  TIME_OF_DAY,
} from '../constants';
import { FREQUENCY_UNIT } from '../../MedicationPage/constants';

const CheckboxContainer = styled(GridItem)`
  margin-top: 1em;
`;

const FREQUENCY_MIN = 1;
const FREQUENCY_UNIT_OPTIONS = [
  {
    value: 'day',
    label: 'day',
  },
  {
    value: 'hour',
    label: 'hour',
  },
  {
    value: 'week',
    label: 'week',
  },
  {
    value: 'unique visit',
    label: 'unique visit',
  },
];
const HALF_HOURS_PER_DAY = 24 * 2;
const IDLE_TIME_MIN = 0;

const getTimeOptions = () => {
  const midnight = startOfDay(new Date(1, 1, 1));

  return times(HALF_HOURS_PER_DAY, multiplier => {
    const datetime = addMinutes(midnight, 30 * multiplier);

    return {
      label: format(datetime, 'h:mm a'),
      value: toISOStringNoZone(datetime),
    };
  });
};

function Notification({ paths, ...rest }) {
  return (
    <GridContainer spacing={24}>
      <GridItem xs={12}>
        <Field
          component={TextFieldWrapper}
          id={NOTIFICATION_TEXT}
          label="Notification Text"
          multiline
          name={join([...paths, NOTIFICATION_TEXT], '.')}
          paths={[...paths, NOTIFICATION_TEXT]}
          required
          rows="4"
        />
      </GridItem>
      <GridItem lg={3} xs={12}>
        <Field
          component={DropdownWrapper}
          id={LOCATION}
          label="Location"
          name={join([...paths, LOCATION], '.')}
          paths={[...paths, LOCATION]}
          required
        >
          <MenuItem value={LOCATION_TYPES.DOCTOR.value}>
            {LOCATION_TYPES.DOCTOR.label}
          </MenuItem>
          <MenuItem value={LOCATION_TYPES.PHARMACY.value}>
            {LOCATION_TYPES.PHARMACY.label}
          </MenuItem>
          <MenuItem value={LOCATION_TYPES.HOME.value}>
            {LOCATION_TYPES.HOME.label}
          </MenuItem>
        </Field>
      </GridItem>
      <FrequencyForm
        frequencyFieldName={FREQUENCY}
        min={FREQUENCY_MIN}
        options={FREQUENCY_UNIT_OPTIONS}
        paths={paths}
        unitsFieldName={FREQUENCY_UNIT}
      />
      <GridItem lg={4} xs={12}>
        <Field
          component={TextFieldWrapper}
          id={IDLE_TIME}
          inputProps={{ min: IDLE_TIME_MIN }}
          label="Idle Time"
          name={join([...paths, IDLE_TIME], '.')}
          paths={[...paths, IDLE_TIME]}
          required
          type="number"
        />
      </GridItem>
      <GridItem lg={4} xs={12}>
        <Field
          component={DropdownWrapper}
          id={TIME_OF_DAY}
          label="Time of Day"
          name={join([...paths, TIME_OF_DAY], '.')}
          paths={[...paths, TIME_OF_DAY]}
        >
          {getTimeOptions().map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Field>
      </GridItem>
      <CheckboxContainer lg={4} xs={12}>
        <Field
          component={CheckboxWrapper}
          id={STATUS}
          label="Active"
          name={join([...paths, STATUS], '.')}
          paths={[...paths, STATUS]}
          required
        />
      </CheckboxContainer>
    </GridContainer>
  );
}

Notification.propTypes = {
  paths: PropTypes.array,
};

Notification.defaultProps = {
  paths: [],
};

export default Notification;



// WEBPACK FOOTER //
// ./src/modules/NotificationManagement/components/Notification.js